import React from 'react';
import type { SortDescriptor } from '@react-types/shared';
import { createSortDescriptor } from '@/components/table';
import { RoleItem } from '@/types';

export const useRolesSorting = (roles: RoleItem[]) => {
  const [sortDescriptor, setSortDescriptor] = React.useState<SortDescriptor | undefined>(undefined);

  const sortedRoles = React.useMemo(() => {
    if (!sortDescriptor?.column) return roles;

    const copy = [...roles];
    const { column, direction } = sortDescriptor;

    const compareStrings = (a: string | null | undefined, b: string | null | undefined) => {
      const aStr = a || '';
      const bStr = b || '';
      return aStr.localeCompare(bStr, undefined, { sensitivity: 'base' });
    };

    const compareNumbers = (a: number | null | undefined, b: number | null | undefined) => {
      const aNum = a || 0;
      const bNum = b || 0;
      return aNum - bNum;
    };

    copy.sort((a, b) => {
      let cmp = 0;

      switch (column) {
        case 'name':
          cmp = compareStrings(a.name, b.name);
          break;
        case 'description':
          cmp = compareStrings(a.description, b.description);
          break;
        case 'users_count':
          cmp = compareNumbers(a.users_count, b.users_count);
          break;
        case 'created_at':
          cmp = compareStrings(a.created_at, b.created_at);
          break;
        case 'updated_at':
          cmp = compareStrings(a.updated_at, b.updated_at);
          break;
        default:
          cmp = 0;
      }

      return direction === 'descending' ? -cmp : cmp;
    });

    return copy;
  }, [roles, sortDescriptor]);

  return { sortDescriptor, setSortDescriptor, sortedRoles };
};
